import React from "react";
import ReactSelect from "react-select";
import { SelectBody } from "./selectBody";

export const Select = ({ ...props }) => {
	return <SelectBody component={ReactSelect} {...props} />;
};
